export default __webpack_public_path__ + "static/media/pocket-drop.04c4debe.mp3";